import { render } from "./product-group-image-attachment.vue?vue&type=template&id=1dc63842"
import script from "./product-group-image-attachment.vue?vue&type=script&lang=js"
export * from "./product-group-image-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__